export const REGION_RUM_CONTEXT_KEYS = {
  REGION: 'region',
  REGION_ID: 'region_id',
} as const
